import { render, staticRenderFns } from "./ModalProductItem.vue?vue&type=template&id=5643fbcb&scoped=true&"
import script from "./ModalProductItem.vue?vue&type=script&lang=js&"
export * from "./ModalProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductItem.vue?vue&type=style&index=0&id=5643fbcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643fbcb",
  null
  
)

export default component.exports